export default __webpack_public_path__ + "static/media/bg_orange_01.8bdf58ef.png";